import moment from 'moment-timezone';
import Catalyst from '@Services/Catalyst';
import { getProjectRouteLevelContent, getStepLevelContent } from '@Pages/RetroSynthesis/ProjectRoute/analytics';

const getRecordDateAndAgeForAA = (recordDate, currentDate) => {
  if (!recordDate) {
    return { date: '', age: '' };
  }
  const recordMoment = moment(recordDate);
  const currentMoment = moment(currentDate);
  return {
    date: recordMoment.format('YYYY-MM-DD'),
    age: String(currentMoment.diff(recordMoment, 'days')),
  };
};

export const onFullTextLinkClicked = ({
  projectId,
  routeId,
  stepNumber,
  routeType,
  projectInfo,
  dataId,
  dataName,
  recordDate,
  currentDate,
  linkLocation,
  dataCitationType,
}) => {
  const { date, age } = getRecordDateAndAgeForAA(recordDate, currentDate);
  Catalyst.trackEvent('linkOut', {
    content: [
      {
        id: `rx2:linkout:${dataId}`,
        linkOut: dataName,
        type: 'rx2:linkout:retrosynthesis:full text',
        date,
        age,
      },
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    link: {
      location: linkLocation,
      name: dataName,
      type: dataCitationType,
    },
  });
};

export const onExperimentalProcedureOpened = ({
  projectId,
  routeId,
  stepNumber,
  routeType,
  projectInfo,
  dataId,
  recordDate,
  currentDate,
}) => {
  const { date, age } = getRecordDateAndAgeForAA(recordDate, currentDate);
  Catalyst.trackEvent('contentView', {
    content: [
      {
        id: `rx2:cit:${dataId}`,
        type: 'rx2:contentview:retrosynthesis:experimental procedure',
        date,
        age,
      },
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
  });
};

export const onCitedNTimesClicked = ({
  projectId,
  routeId,
  stepNumber,
  routeType,
  projectInfo,
  dataId,
  dataName,
  recordDate,
  currentDate,
  linkLocation,
  dataCitationType,
}) => {
  const { date, age } = getRecordDateAndAgeForAA(recordDate, currentDate);
  Catalyst.trackEvent('linkOut', {
    content: [
      {
        id: `rx2:linkout:${dataId}`,
        linkOut: dataName,
        type: 'rx2:linkout:retrosynthesis:cited',
        date,
        age,
      },
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    link: {
      location: linkLocation,
      name: dataName,
      type: dataCitationType,
    },
  });
};

export const onAbstractOpened = ({ projectId, routeId, stepNumber, routeType, projectInfo, dataId, recordDate, currentDate }) => {
  const { date, age } = getRecordDateAndAgeForAA(recordDate, currentDate);
  Catalyst.trackEvent('contentView', {
    content: [
      {
        id: `rx2:cit:${dataId}`,
        type: 'rx2:contentview:retrosynthesis:abstract',
        date,
        age,
      },
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
  });
};

export const onAuthorNameClicked = ({
  projectId,
  routeId,
  stepNumber,
  routeType,
  projectInfo,
  dataId,
  dataName,
  recordDate,
  currentDate,
  linkLocation,
  dataCitationType,
}) => {
  const { date, age } = getRecordDateAndAgeForAA(recordDate, currentDate);
  Catalyst.trackEvent('linkOut', {
    content: [
      {
        id: `rx2:linkout:${dataId}`,
        linkOut: dataName,
        type: 'rx2:linkout:retrosynthesis:author name',
        date,
        age,
      },
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    link: {
      location: linkLocation,
      name: dataName,
      type: dataCitationType,
    },
  });
};

export const onViewSelectedClicked = ({ selected, projectId, projectInfo, routeId, routeType, stepNumber }) => {
  Catalyst.trackEvent('buttonClick', {
    content: [
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    buttonType: `button:view selected:${selected ? 'on' : 'off'}`, // v124
  });
};

export const onSelectedClicked = ({ selectedResults, projectId, projectInfo, routeId, routeType, stepNumber }) => {
  Catalyst.trackEvent('searchResultsClick', {
    content: [
      ...getProjectRouteLevelContent({ projectId, routeId, routeType, projectInfo }),
      getStepLevelContent({ projectId, routeId, stepNumber }),
    ],
    search: {
      resultsPosition: selectedResults, // <result_position>, evar15
    },
    link: {
      location: 'step', // evar118
      name: 'checkbox-on', // evar119
    },
  });
};
